export const mockData = [
  {
    id: 1,
    semanticId: "SEM-1001",
    component: "Pipe",
    status: "Matched",

    Cost: {
      left: 1200,
      right: 1200,
      variance: 0,
    },

    Quantity: {
      left: 100,
      right: 110,
      variance: 10,
    },

    "Lead Time": {
      left: "5 Days",
      right: "7 Days",
      variance: 2,
    },

    Weight: {
      left: 55,
      right: 55,
      variance: 0,
    },

    "2D Drawing Compliance": {
      left: "Compliant",
      right: "Compliant",
      variance: "-",
    },
  },

  {
    id: 2,
    semanticId: "SEM-1002",
    component: "Gate Valve 2in",
    status: "Variance Found",

    Cost: {
      left: 950,
      right: 1100,
      variance: 150,
    },

    Quantity: {
      left: 20,
      right: 18,
      variance: -2,
    },

    "Lead Time": {
      left: "12 Days",
      right: "9 Days",
      variance: -3,
    },

    Weight: {
      left: 22,
      right: 25,
      variance: 3,
    },

    "2D Drawing Compliance": {
      left: "Non-Compliant",
      right: "Compliant",
      variance: "Mismatch",
    },
  },

  {
    id: 3,
    semanticId: "SEM-1003",
    component: "Reducer 4x2",
    status: "Missing In B",

    Cost: {
      left: 300,
      right: null,
      variance: null,
    },

    Quantity: {
      left: 15,
      right: null,
      variance: null,
    },

    "Lead Time": {
      left: "4 Days",
      right: null,
      variance: null,
    },

    Weight: {
      left: 8,
      right: null,
      variance: null,
    },

    "2D Drawing Compliance": {
      left: "Compliant",
      right: null,
      variance: null,
    },
  },

  {
    id: 4,
    semanticId: "SEM-1004",
    component: "Flange RF 6in",
    status: "Missing In A",

    Cost: {
      left: null,
      right: 700,
      variance: null,
    },

    Quantity: {
      left: null,
      right: 12,
      variance: null,
    },

    "Lead Time": {
      left: null,
      right: "8 Days",
      variance: null,
    },

    Weight: {
      left: null,
      right: 17,
      variance: null,
    },

    "2D Drawing Compliance": {
      left: null,
      right: "Compliant",
      variance: null,
    },
  },

  {
    id: 5,
    semanticId: "SEM-1005",
    component: "Control Panel",
    status: "Major Variance",

    Cost: {
      left: 15000,
      right: 18200,
      variance: 3200,
    },

    Quantity: {
      left: 1,
      right: 1,
      variance: 0,
    },

    "Lead Time": {
      left: "45 Days",
      right: "60 Days",
      variance: 15,
    },

    Weight: {
      left: 120,
      right: 145,
      variance: 25,
    },

    "2D Drawing Compliance": {
      left: "Pending",
      right: "Approved",
      variance: "Status Changed",
    },
  },

  {
    id: 6,
    semanticId: "SEM-1006",
    component: "Cable Tray",
    status: "Matched",

    Cost: {
      left: 2400,
      right: 2400,
      variance: 0,
    },

    Quantity: {
      left: 300,
      right: 300,
      variance: 0,
    },

    "Lead Time": {
      left: "14 Days",
      right: "14 Days",
      variance: 0,
    },

    Weight: {
      left: 210,
      right: 210,
      variance: 0,
    },

    "2D Drawing Compliance": {
      left: "Compliant",
      right: "Compliant",
      variance: "-",
    },
  },

  {
    id: 7,
    semanticId: "SEM-1007",
    component: "Instrumentation Cable",
    status: "Variance Found",

    Cost: {
      left: 8000,
      right: 7600,
      variance: -400,
    },

    Quantity: {
      left: 1000,
      right: 950,
      variance: -50,
    },

    "Lead Time": {
      left: "20 Days",
      right: "25 Days",
      variance: 5,
    },

    Weight: {
      left: 500,
      right: 470,
      variance: -30,
    },

    "2D Drawing Compliance": {
      left: "Approved",
      right: "Approved With Comments",
      variance: "Comments Added",
    },
  },

  {
    id: 8,
    semanticId: "SEM-1008",
    component: "Pump Skid",
    status: "Critical Variance",

    Cost: {
      left: 55000,
      right: 73000,
      variance: 18000,
    },

    Quantity: {
      left: 2,
      right: 3,
      variance: 1,
    },

    "Lead Time": {
      left: "90 Days",
      right: "120 Days",
      variance: 30,
    },

    Weight: {
      left: 1800,
      right: 2200,
      variance: 400,
    },

    "2D Drawing Compliance": {
      left: "Approved",
      right: "Rejected",
      variance: "Critical",
    },
  },
];
